/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const DISCOVER_VENUES = graphql(`
  query DiscoverVenues($where: venues_bool_exp!) {
    venues(where: $where, order_by: { shorthand_name: asc }) {
      _id
      shorthand_name
    }
  }
`);
